import React, { forwardRef } from "react";
import { Controller } from "react-hook-form";
import NumberFormat from "react-number-format";
import PN from "persian-number";
import { cn } from "../../utils/utils";
import styles from "./Styles.module.css";

const CustomPaymentNumberInput = forwardRef((props) => {
  const {
    control,
    name,
    label,
    errors,
    placeholder,
    className,
    disabled,
    maxValue,

  } = props;

  return (
    <div className={cn("textInputWrapper", className)}>
      <Controller
        control={control}
        name={name}
        render={({ field: { onChange, value,ref } }) => {
          const handleValueChange = (values) => {
            onChange(PN.convertPeToEn(values.formattedValue));
          };

          return (
            <div className={styles.formField}  >
    
              <div className="flex gap-2 font-semibold text-[14px]   items-center">
                {label}{" "}
                {errors && (
                  <div className="error-text">{errors?.message}</div>
                )}
              </div>

              <NumberFormat
                value={value ? value : ""}
                displayType={"input"}
                 className="h-[52px] px-2 outline-none rounded-v-md w-full border-[1px] border-[#ccc] disabled:bg-neutral-10 disabled:border-none"
                thousandSeparator={true}
                onValueChange={handleValueChange}
                disabled={disabled}
                allowNegative={false}
                placeholder={placeholder}
                dir="ltr"
                isAllowed={(values) => {
                  const { floatValue } = values;
                  if (floatValue > maxValue) return false;
                  return true;
                }}
                getInputRef={ref} // Pass the ref here for focusing
              />
            </div>
          );
        }}
      />
    </div>
  );
});

export default CustomPaymentNumberInput;
